import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { InputModel } from "@starter/Framework/Store/Starter/Components/Form/FormTypes";
import { createSelector } from "reselect";

export const getForms = (state: ApplicationState) => {
    return state.starter.components.form.forms;
};

const selectForms = (state: ApplicationState) => getForms(state);
const selectFormId = (state: ApplicationState, id: string) => id;

export const getFormById = createSelector(
    [selectForms, selectFormId],
    (forms, id) => forms.find(form => form.id === id) ?? null,
);

const EMPTY_ARRAY: InputModel[] = [];
export const getInputs = createSelector(
    [(state: ApplicationState, formId: string) => getFormById(state, formId)],
    form => form?.inputs ?? EMPTY_ARRAY,
);

export const getInputById = (state: ApplicationState, inputId: string | number, formId: string) => {
    return getInputs(state, formId).find(x => x.id === inputId) || null;
};

export const getFirstInputInError = (state: ApplicationState, formId: string) => {
    return getInputs(state, formId).find(x => x.error !== undefined && x.error !== "") || null;
};

export const hasErrorInForm = (state: ApplicationState, formId: string) => {
    return getInputs(state, formId).some(x => x.error);
};
